module.exports = __webpack_public_path__ + "img/zu14.62e80024.svg";